import { createEvent, restore } from 'effector';

// * events
export const setQuestionEvent = createEvent<string>();

// * stores
export const $question = restore(setQuestionEvent, '');
